var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"app"},on:{"mousemove":_vm.mousemove}},[_c('section',{staticClass:"products"},_vm._l((_vm.products),function(product){return _c('product',{key:product.color,attrs:{"product":product}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }